import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Home,
  Handshake,
  Megaphone,
  Map,
  Heart,
  Palette,
  Camera,
  Building2,
  Users,
  ChevronRight,
} from 'lucide-react';
import ModalPortal from '../Modal/ModalPortal';
import './WelcomeModal.sass';

const buildQuickActions = ({ email, userType }) => {
  const actions = [];

  if (userType === 'host') {
    actions.push({
      icon: Home,
      label: 'Add Additional Properties',
      path: email
        ? `/property/editor?email=${encodeURIComponent(email)}`
        : '/property/editor',
    });
  }

  actions.push(
    { icon: Handshake, label: 'Pitch a collab on the Collab Board', path: '/collab-board' },
    { icon: Megaphone, label: 'Add an announcement to the Travel Board', path: '/travel-board' },
    { icon: Map, label: 'Upload an Itinerary', path: '/itineraries' },
    { icon: Heart, label: 'Create a list of favorites', path: '/creators' },
    { icon: Palette, label: 'Customize a collab template', path: '/collabs/draft' },
    { icon: Camera, label: 'Upload an image to be featured on @postawaytravels', path: '/get-featured' },
    { icon: Building2, label: 'Read Host reviews', path: '/hosts/reviews' },
    { icon: Users, label: 'Read Creator reviews', path: '/creators/reviews' },
  );

  return actions;
};

const WelcomeModal = ({ isOpen, onClose, firstName, email, userType }) => {
  const navigate = useNavigate();
  const quickActions = buildQuickActions({ email, userType });

  const messageParts = [
    `Welcome to Postaway${firstName ? `, ${firstName}` : ''}. You are officially a member of the best hospitality group in the country!`,
    `Postaway was designed to help you connect, collaborate and build community with creators, hosts and travelers. Please reach out with any questions you have about the platform and let us know what features you'd like to see in the future.`,
    `We wish you great success in your journey, and look forward to seeing the places you'll go!`,
    `xoxo, Jamie (Founder & CEO)`
  ];

  const handleActionClick = (path) => {
    onClose();
    navigate(path);
  };

  return (
    <ModalPortal isOpen={isOpen} onClose={onClose} maxWidth="640px" maxHeight="90vh">
      <div className="welcome-modal-content">
        <div className="welcome-modal-message">
          {messageParts.map((paragraph, idx) => (
            <p key={idx} className="welcome-modal-paragraph">
              {paragraph}
            </p>
          ))}
        </div>

        <div className="welcome-modal-routing">
          <h3 className="welcome-modal-routing-heading">
            What would you like to do first?
          </h3>
          <ul className="welcome-modal-action-list">
            {quickActions.map(({ icon: Icon, label, path }) => (
              <li key={path}>
                <button
                  className="welcome-modal-action-item"
                  onClick={() => handleActionClick(path)}
                  type="button"
                >
                  <span className="welcome-modal-action-icon">
                    <Icon size={20} strokeWidth={1.8} />
                  </span>
                  <span className="welcome-modal-action-label">{label}</span>
                  <ChevronRight size={16} className="welcome-modal-action-chevron" />
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="welcome-modal-actions">
          <button
            className="welcome-modal-button"
            onClick={onClose}
            type="button"
          >
            Maybe Later
          </button>
        </div>
      </div>
    </ModalPortal>
  );
};

export default WelcomeModal;

